import baseAPI from "@/http";

const router = "api/contratos";

export const contratosAPI = {
  create: (contrato) => baseAPI.post(router, contrato),
  update: (contrato) => baseAPI.put(router, contrato),
  delete: (id) => baseAPI.delete(`${router}/${id}`),
  list: () => baseAPI.get(router),
  listByUsers: (usuariosId) =>
    baseAPI.post(`${router}/obter-contrato-por-usuarios`, usuariosId),

  listByUser: (usuarioId) =>
    baseAPI.get(`${router}/obter-contrato-por-usuario?usuarioId=${usuarioId}`),
  find: (id) => baseAPI.get(`${router}/${id}`),
  downloadContrato: (contratoId) =>
    baseAPI.post(`${router}/download-contrato?contratoId=${contratoId}`, null, {
      responseType: "blob",
    }),
  ativarReativar: (contrato) =>
    baseAPI.put(
      `${router}/ativar-inativar?ativoInativo=${contrato.ativoInativo}&contratoid=${contrato.contratoid} `,
      contrato
    ),
};
